import { unauthenticatedApiClient } from '../apiClient';
import { PLATFORM_LEGAL_CORPORATION_ID } from '../constants';
import { ApiActionResponse } from '../types';
import { PartialSubscriptionRequestBody, SubscriptionRequestBody } from './types';

export const submitSubscriptionRequest = (
  partialSubscriptionRequestBody: PartialSubscriptionRequestBody,
) => {
  const data: SubscriptionRequestBody = {
    ...partialSubscriptionRequestBody,
    legalCorporationId: PLATFORM_LEGAL_CORPORATION_ID,
  };

  return unauthenticatedApiClient.request<ApiActionResponse>(
    'POST',
    '/submit-subscription-request',
    data,
  );
};
